import { Link } from "react-router-dom";
import HeroBanner from "./components/HeroBanner";
import FeaturedCarousel from "./components/FeaturedCarousel";
import CategoryGrid from "./components/CategoryGrid";
import SiteIntro from "./components/SiteIntro";
import SectionHeading from "@/components/base/SectionHeading";
import SeriesCard from "@/components/base/SeriesCard";
import NewsCard from "@/components/base/NewsCard";
import { seriesList } from "@/mocks/series";
import { newsList } from "@/mocks/news";

export default function Home() {
  const latestSeries = [...seriesList]
    .sort((a, b) => b.releaseDate.localeCompare(a.releaseDate))
    .slice(0, 8);

  const latestNews = [...newsList]
    .sort((a, b) => b.date.localeCompare(a.date))
    .slice(0, 5);

  return (
    <>
      <HeroBanner />

      <section className="mx-auto w-full max-w-7xl px-4 py-12 md:px-8 md:py-16">
        <SectionHeading
          eyebrow="Featured"
          title="焦点推荐"
          description="编辑部本周精选的 AI 短剧，涵盖硬核科幻、心理悬疑与温情剧情。"
        />
        <FeaturedCarousel />
      </section>

      <section className="mx-auto w-full max-w-7xl px-4 pb-12 md:px-8 md:pb-16">
        <SectionHeading
          eyebrow="Categories"
          title="按类型探索"
          description="九大内容类型，总有一款符合你今晚的心情。"
          to="/category"
          toLabel="进入分类页"
        />
        <CategoryGrid />
      </section>

      <section className="mx-auto w-full max-w-7xl px-4 py-12 md:px-8 md:py-16">
        <SectionHeading
          eyebrow="Latest"
          title="最新短剧推荐"
          description="按上线时间倒序整理，卡片包含封面、类型标签与剧情简介。"
          to="/category"
          toLabel="浏览全部短剧"
        />
        <div className="grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-4 lg:gap-5">
          {latestSeries.map((series) => (
            <SeriesCard key={series.id} series={series} />
          ))}
        </div>
      </section>

      <section className="w-full bg-background-100">
        <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-8 md:py-20">
          <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
            <div className="lg:col-span-7">
              <SectionHeading
                eyebrow="News"
                title="最新短剧资讯"
                description="行业动态、作品观察与创作手记，了解 AI 短剧正在发生什么。"
                to="/news"
                toLabel="查看全部资讯"
              />
              <div className="flex flex-col gap-4">
                {latestNews.map((article) => (
                  <NewsCard key={article.id} article={article} />
                ))}
              </div>
            </div>

            <aside className="lg:col-span-5">
              <div className="lg:sticky lg:top-24">
                <div className="rounded-lg border border-background-200 bg-background-50 p-6">
                  <h3 className="font-heading text-base font-semibold text-foreground-950">
                    热门标签
                  </h3>
                  <div className="mt-4 flex flex-wrap gap-2">
                    {[
                      "硬核科幻",
                      "心理悬疑",
                      "赛博朋克",
                      "古风",
                      "单元剧",
                      "AI动画",
                      "群像",
                      "温情",
                    ].map((tag) => (
                      <Link
                        key={tag}
                        to={`/search?q=${encodeURIComponent(tag)}`}
                        className="rounded-full bg-secondary-100 px-3 py-1.5 text-xs font-medium text-secondary-800 transition-colors hover:bg-accent-500 hover:text-foreground-950"
                      >
                        {tag}
                      </Link>
                    ))}
                  </div>
                </div>

                <div className="mt-4 rounded-lg border border-background-200 bg-background-50 p-6">
                  <h3 className="font-heading text-base font-semibold text-foreground-950">
                    编辑推荐
                  </h3>
                  <ul className="mt-4 space-y-4">
                    {seriesList
                      .filter((item) => item.score >= 9)
                      .slice(0, 3)
                      .map((item, index) => (
                        <li key={item.id}>
                          <Link to={`/detail/${item.id}`} className="group flex gap-3">
                            <span className="font-heading text-lg font-bold text-primary-300">
                              {String(index + 1).padStart(2, "0")}
                            </span>
                            <span className="min-w-0">
                              <span className="block truncate text-sm font-medium text-foreground-900 transition-colors group-hover:text-primary-600">
                                {item.title}
                              </span>
                              <span className="mt-0.5 block text-xs text-foreground-400">
                                {item.categoryName} · {item.score} 分
                              </span>
                            </span>
                          </Link>
                        </li>
                      ))}
                  </ul>
                </div>
              </div>
            </aside>
          </div>
        </div>
      </section>

      <SiteIntro />
    </>
  );
}